//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "BalthazarCTModified_info",

}



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/GIT/BalthazarCTModified_info.vue